module.exports = __webpack_public_path__ + "img/pastReunions.7341e9eb.jpg";